// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: true,
  version: env.npm_package_version,
  pageRoot: '/',
  themeRoot: '/wp-content/themes/elumine-child/',
  ssoServer: 'https://sso.staatsanzeiger.de/api/',
  defaultLanguage: 'DE'
};
